import { apiBaseUrlSelector, tokenSelector } from '../selectors/global';

export const START = 'START';
export const SUCCESS = 'SUCCESS';
export const ERROR = 'ERROR';

export function createRequestTypes (base) {
  return [ START, SUCCESS, ERROR ].reduce((acc, type) => {
    acc[type] = `${base}_${type}`;
    return acc;
  }, {});
}

export function makeApiActionCreator (
  _apiCall,
  startActionType,
  successActionType,
  errorActionType
) {
  return function (params) {
    return async (dispatch, getState) => {
      const state = getState();
      const apiBaseUrl = apiBaseUrlSelector(state);
      const apiKey = tokenSelector(state);
      dispatch({ ...params, type: startActionType });
      try {
        const data = await _apiCall(apiBaseUrl, apiKey, params);
        dispatch({ ...params, data, type: successActionType });
        return data;
      } catch (error) {
        dispatch({ ...params, error, type: errorActionType });
        throw error;
      }
    };
  };
}

export function getOfficeFromUrl () {
  const urlTokens = window.location.href
    .replace(/http:\/\/|https:\/\//gi, '')
    .split('.');
  if (urlTokens.length < 2) {
    return;
  }
  const idx = urlTokens.findIndex(
    token =>
      token === 'trueprodigy-taxtransparency' || token === 'taxratestexas'
  );
  if (idx < 1) {
    return;
  }
  const office = idx && urlTokens[idx - 1].toLowerCase();
  if ([ 'dev', 'stage', 'www' ].includes(office)) {
    return;
  }
  return office.replace(/\b\w/g, l => l.toUpperCase());
}
